import styled from 'styled-components';

const Wrapper = styled.div`
  width: 820px;
  transition: all 0.5s ease-out;
  @media only screen and (max-width: 1024px) {
    width: auto;
  }
`;

export default Wrapper;